// import { useDispatch } from "react-redux";
// import { login } from "../redux/slices/authSlice";
import { useEffect, useState } from "react";
import LockRounded from '@mui/icons-material/LockRounded';

const UnauthorizedPage = () => {
  const [isMobile, setIsMobile] = useState(false);
  
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    }
    handleResize();
    window.addEventListener('resize', handleResize);
  }, []);

  return <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginTop: '1rem' }}>
    <LockRounded style={{
      fontSize: 30, color: '#ffd300', ...(isMobile && {
        marginTop: '5rem',
        fontSize: 20
      })
    }} />
    <h2 style={{
      ...(isMobile && {
        fontSize: '12px'
      })
    }}>This page does not exist or you are not authorized to access it!</h2></div>;
};

export default UnauthorizedPage;
